module.exports = __webpack_public_path__ + "static/fonts/iconfont.9c3804e.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/content_font/iconfont.eot?t=1614850630108
// module id = Nzzw
// module chunks = 133